export default __webpack_public_path__ + "static/media/starlight.30f8daf7.png";